<template>
  <SiruiSearch
    ref="formItem"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
    @changeMethod="changeMethod"
    @changeChecked="changeChecked"
  >
  </SiruiSearch>
</template>

<script>
  import BaseInfoMixin from './../BaseInfoMixin.js';
  import { baseForm, baseFormRule } from './index.js';
  export default {
    name: 'BaseInfoAgreement',
    mixins: [BaseInfoMixin],
    props: {
      // 远程数据
      fetchData: {
        type: Object,
        default: () => {},
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
    },
    computed: {
      formColumn() {
        // return baseForm(this);
        return this._getStatusRelatedBaseForm(this);
      },
      formRules() {
        return baseFormRule(this);
      },
    },
    methods: {
      _getStatusRelatedBaseForm() {
        var tableColumns = baseForm(this);

        var cs = this.contractStatus;

        var disabledList = [
          'contractCreateDate',
          'contractNo',
          'projectName',
          'contractOperaterName',
          'isFixedPrice',
        ];
        if (cs == 'ZT02' || cs == 'ZT03') {
          disabledList = disabledList.concat([
            'contractName',
            'customerName',
            'projectInitiationNo',
            'contractBusinessCompanyNo',
            'contractType',
            'contractBusinessDepartment',
            'signDate',
            'contractValidStart',
            'contractValidEnd',
            'isNotEndDate',
            'contractCurrency',
            'mark',
            'isDefault',
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'qualityGuaranteeDepositMethodCode',
            'chargeFixedValue',
            'chargeProportion',
            'qualityGuaranteeDepositOverdue',
            'performanceBondPayMethodCode',
            'performanceBond',
            'warrantyClause',
            'overShippedPercentage',
            'shortShippedPercentage',
            'businessType',
            'isFixedPrice',
            'pricingRule',
            'receiptMethod',
            'incomeMethod',
            'isRestrict',
            'isLongRange',
            'performanceBondRecipient',
            'externalContractNo',
          ]);
        }
        if (this.baseFormData.companyCode == '') {
          disabledList.push('contractBusinessDepartment');
        }

        if (!this.baseFormData.projectInitiationNo || this.baseFormData.projectInitiationNo == '') {
          disabledList.push('platformCompanyFileNo');
        }

        if (this.baseFormData.isDefault != '1') {
          disabledList = disabledList.concat([
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
            'qualityGuaranteeDepositMethodCode',
            'chargeFixedValue',
            'chargeProportion',
            'qualityGuaranteeDepositOverdue',
          ]);
        }

        if (this.baseFormData.liquidatedDamagesType != 'FIXED') {
          disabledList.push('liquidatedFixedValue');
        }
        if (this.baseFormData.liquidatedDamagesType != 'RATE') {
          disabledList.push('liquidatedInterestRate');
        }

        if (this.baseFormData.qualityGuaranteeDepositMethodCode != 'FIXED') {
          disabledList.push('chargeFixedValue');
        }
        if (this.baseFormData.qualityGuaranteeDepositMethodCode != 'RATE') {
          disabledList.push('chargeProportion');
        }

        if (
          !this.baseFormData.qualityGuaranteeDepositMethodCode ||
          this.baseFormData.qualityGuaranteeDepositMethodCode == ''
        ) {
          disabledList.push('qualityGuaranteeDepositOverdue');
        }

        // if (
        //   !this.baseFormData.platformCompanyFileNo ||
        //   this.baseFormData.platformCompanyFileNo == ''
        // ) {
        //   disabledList.push('projectInitiationNo');
        // }

        console.log('formStatus', 'list: ', disabledList, 'status: ', cs);

        return tableColumns.map((item) => {
          if (disabledList.includes(item.prop)) {
            return { ...item, disabled: true };
          }
          if (item.prop == 'platformCompanyFileNo') {
            if (item.type == 'select') {
              let state = cs != '' && cs != 'ZT06' && cs != 'ZT05';
              return { ...item, disabled: state };
            } else {
              return { ...item, disabled: true };
            }
          }
          return item;
        });
      },
      getformData() {
        return this.baseFormData;
      },
    },
    watch: {
      fetchData: {
        handler(val) {
          if (Object.keys(val).length) {
            let newObj = {};
            for (const key in val) {
              if (typeof val[key] == 'number') {
                newObj[key] = val[key] + '';
              } else {
                newObj[key] = val[key];
              }
            }
            this.baseFormData = newObj;
            this.getProjectByProjectNo(this.baseFormData.projectInitiationNo);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
